module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Claim Items",
      "name": "claim"
    }
  }, [(_vm.currentDoctorName && _vm.isNurse) ? _c('el-alert', {
    staticStyle: {
      "margin-bottom": "15px"
    },
    attrs: {
      "title": ("Currently claiming for: " + _vm.currentDoctorName),
      "type": "info",
      "closable": false,
      "show-icon": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    ref: "claimForm",
    attrs: {
      "model": _vm.claimForm,
      "rules": _vm.claimRules,
      "label-width": "120px"
    }
  }, [(_vm.isNurse) ? _c('el-row', {
    staticClass: "form-row-spaced",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Available Inbound",
      "prop": "inboundNo"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "Filter Inbound by typing 4+ UPC characters, or select Inbound to batch import.",
      "clearable": "",
      "filterable": "",
      "remote": "",
      "remote-method": _vm.searchAvailableInbounds,
      "loading": _vm.availableInboundsLoading
    },
    on: {
      "change": _vm.onInboundChange
    },
    model: {
      value: (_vm.claimForm.inboundNo),
      callback: function($$v) {
        _vm.$set(_vm.claimForm, "inboundNo", $$v)
      },
      expression: "claimForm.inboundNo"
    }
  }, [_vm._l((_vm.availableInbounds), function(inbound) {
    return _c('el-option', {
      key: inbound.inboundNo,
      attrs: {
        "label": ((inbound.productName) + " - Qty: " + (inbound.qty) + ", Left: " + (inbound.leftNum) + " (" + (inbound.warehouse) + ")"),
        "value": inbound.inboundNo
      }
    }, [_c('span', {
      staticStyle: {
        "float": "left"
      }
    }, [_vm._v(_vm._s(inbound.productName))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right",
        "color": "#8492a6",
        "font-size": "13px"
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tLeft: " + _vm._s(inbound.leftNum) + "/" + _vm._s(inbound.qty) + "\n\t\t\t\t\t\t\t\t\t\t\t")])])
  }), _vm._v(" "), (_vm.availableInbounds.length === 0) ? _c('el-option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tNo incomplete inbound records available\n\t\t\t\t\t\t\t\t\t\t")]) : _vm._e()], 2)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isNurse && _vm.selectedInboundInfo) ? _c('el-row', {
    staticClass: "form-row-spaced",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('InboundStatusCard', {
    attrs: {
      "inbound": _vm.selectedInboundInfo,
      "show-actions": false
    },
    on: {
      "status-refreshed": _vm.onInboundStatusRefreshed
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-row', {
    staticClass: "form-row-spaced",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Tracking #",
      "prop": "tracking"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Enter tracking number",
      "clearable": ""
    },
    on: {
      "blur": _vm.searchTrackingInfo
    },
    model: {
      value: (_vm.claimForm.tracking),
      callback: function($$v) {
        _vm.$set(_vm.claimForm, "tracking", $$v)
      },
      expression: "claimForm.tracking"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "UPC",
      "prop": "upc"
    }
  }, [_c('el-input', {
    class: {
      'readonly-input': _vm.isNurse && _vm.selectedInboundInfo && _vm.selectedInboundInfo.upc
    },
    attrs: {
      "placeholder": _vm.getUpcPlaceholder(),
      "readonly": !!(_vm.isNurse && _vm.selectedInboundInfo && _vm.selectedInboundInfo.upc),
      "clearable": ""
    },
    on: {
      "blur": _vm.validateUpcMatch
    },
    model: {
      value: (_vm.claimForm.upc),
      callback: function($$v) {
        _vm.$set(_vm.claimForm, "upc", $$v)
      },
      expression: "claimForm.upc"
    }
  }, [(_vm.isNurse && _vm.selectedInboundInfo && _vm.selectedInboundInfo.upc) ? _c('template', {
    slot: "suffix"
  }, [_c('i', {
    staticClass: "el-icon-lock",
    staticStyle: {
      "color": "#909399"
    }
  })]) : _vm._e()], 2), _vm._v(" "), (_vm.isNurse && _vm.selectedInboundInfo && _vm.selectedInboundInfo.upc) ? _c('div', {
    staticClass: "readonly-hint"
  }, [_c('i', {
    staticClass: "el-icon-info"
  }), _vm._v(" Automatically filled from selected Inbound record\n\t\t\t\t\t\t\t\t\t")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Quantity",
      "prop": "quantity"
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "min": 1,
      "max": _vm.getMaxClaimableQty(),
      "placeholder": "Quantity"
    },
    model: {
      value: (_vm.claimForm.quantity),
      callback: function($$v) {
        _vm.$set(_vm.claimForm, "quantity", $$v)
      },
      expression: "claimForm.quantity"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Warehouse",
      "prop": "warehouseNo"
    }
  }, [_c('el-select', {
    class: {
      'readonly-select': _vm.isNurse && _vm.selectedInboundInfo && _vm.selectedInboundInfo.warehouseNo
    },
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": _vm.getWarehousePlaceholder(),
      "disabled": !!(_vm.isNurse && _vm.selectedInboundInfo && _vm.selectedInboundInfo.warehouseNo)
    },
    model: {
      value: (_vm.claimForm.warehouseNo),
      callback: function($$v) {
        _vm.$set(_vm.claimForm, "warehouseNo", $$v)
      },
      expression: "claimForm.warehouseNo"
    }
  }, _vm._l((_vm.warehouses), function(group) {
    return _c('el-option-group', {
      key: group.label,
      attrs: {
        "label": group.label
      }
    }, _vm._l((group.options), function(item, index) {
      return _c('el-option', {
        key: index,
        attrs: {
          "label": item.state + ' ' + item.city + ' ' + item.address,
          "value": item.warehouseNo
        }
      })
    }), 1)
  }), 1), _vm._v(" "), (_vm.isNurse && _vm.selectedInboundInfo && _vm.selectedInboundInfo.warehouseNo) ? _c('div', {
    staticClass: "readonly-hint"
  }, [_c('i', {
    staticClass: "el-icon-info"
  }), _vm._v(" Automatically selected from Inbound record\n\t\t\t\t\t\t\t\t\t")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "success",
      "loading": _vm.addToListLoading
    },
    on: {
      "click": _vm.addToClaimList
    }
  }, [_vm._v("Add to Claim List")]), _vm._v(" "), (_vm.isNurse) ? _c('el-button', {
    attrs: {
      "type": "warning",
      "disabled": !_vm.claimForm.inboundNo || !_vm.isNurse,
      "loading": _vm.batchImportLoading
    },
    on: {
      "click": _vm.showBatchImportDialog
    }
  }, [_vm._v("Batch Upload")]) : _vm._e(), _vm._v(" "), (!_vm.isNurse) ? _c('el-button', {
    attrs: {
      "type": "warning",
      "disabled": !_vm.claimForm.warehouseNo || _vm.isNurse,
      "loading": _vm.doctorBatchImportLoading
    },
    on: {
      "click": _vm.showDoctorBatchImportDialog
    }
  }, [_vm._v("Batch Upload")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.claimLoading,
      "disabled": _vm.selectedClaims.length === 0
    },
    on: {
      "click": _vm.submitSelectedClaims
    }
  }, [_vm._v("Submit Selected Claims (" + _vm._s(_vm.selectedClaims.length) + ")")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-alert', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "title": "Claim Instructions",
      "description": 'Enter tracking number, UPC, quantity, and select warehouse. Add items to claim list, then submit all claims together.',
      "type": "info",
      "show-icon": "",
      "closable": false
    }
  }), _vm._v(" "), (_vm.claimList.length > 0) ? _c('el-card', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("Claim List (" + _vm._s(_vm.claimList.length) + " items, " + _vm._s(_vm.selectedClaims.length) + " selected)")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary",
      "disabled": _vm.claimList.length === 0
    },
    on: {
      "click": _vm.selectAllClaims
    }
  }, [_vm._v("Select All")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "warning",
      "disabled": _vm.selectedClaims.length === 0
    },
    on: {
      "click": _vm.clearSelection
    }
  }, [_vm._v("Clear Selection")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "danger"
    },
    on: {
      "click": _vm.clearClaimList
    }
  }, [_vm._v("Clear All")])], 1)]), _vm._v(" "), _c('el-table', {
    ref: "claimTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.claimList,
      "border": ""
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), (_vm.isNurse) ? _c('el-table-column', {
    attrs: {
      "prop": "inboundInfo",
      "label": "Inbound",
      "width": "300px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_vm._v(_vm._s(scope.row.productName))]), _vm._v(" "), _c('small', {
          staticClass: "text-muted"
        }, [_vm._v("Inbound #" + _vm._s(scope.row.inboundNo))])]
      }
    }], null, false, 1996151786)
  }) : _vm._e(), _vm._v(" "), (!_vm.isNurse) ? _c('el-table-column', {
    attrs: {
      "prop": "upc",
      "label": "UPC",
      "width": "220px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_vm._v(_vm._s(scope.row.upc))]), _vm._v(" "), _c('small', {
          staticClass: "text-muted"
        }, [_vm._v("Mixed Package Item")])]
      }
    }], null, false, 1752774166)
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tracking",
      "label": "Tracking #",
      "width": "320px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "quantity",
      "label": "Quantity",
      "width": "100px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "warehouseName",
      "label": "Warehouse",
      "min-width": "200px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Actions",
      "width": "100px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.removeFromClaimList(scope.$index)
            }
          }
        }, [_vm._v("Remove")])]
      }
    }], null, false, 244834889)
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "My Claims",
      "name": "myClaims"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.myClaimFilters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Tracking Number",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getMyClaimList.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.myClaimFilters.tracking),
      callback: function($$v) {
        _vm.$set(_vm.myClaimFilters, "tracking", $$v)
      },
      expression: "myClaimFilters.tracking"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getMyClaimList
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "UPC",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getMyClaimList.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.myClaimFilters.upc),
      callback: function($$v) {
        _vm.$set(_vm.myClaimFilters, "upc", $$v)
      },
      expression: "myClaimFilters.upc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "Status",
      "clearable": ""
    },
    model: {
      value: (_vm.myClaimFilters.claimStatus),
      callback: function($$v) {
        _vm.$set(_vm.myClaimFilters, "claimStatus", $$v)
      },
      expression: "myClaimFilters.claimStatus"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Pending Review",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Approved",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Distributed",
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Rejected",
      "value": "3"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Quantity Adjusted",
      "value": "4"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getMyClaimList
    }
  }, [_vm._v("Search")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.myClaimListLoading),
      expression: "myClaimListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.myClaimList,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "tracking",
      "label": "Tracking #",
      "width": "320px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "upc",
      "label": "UPC",
      "width": "250px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Quantity Info",
      "width": "160px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v("Original: "), _c('strong', [_vm._v(_vm._s(scope.row.originalClaimedQty || scope.row.claimedQty))])]), _vm._v(" "), (scope.row.originalClaimedQty && scope.row.originalClaimedQty !== scope.row.claimedQty) ? _c('p', {
          staticClass: "note"
        }, [_vm._v("\n\t\t\t\t\t\t\t\tFinal: "), _c('strong', [_vm._v(_vm._s(scope.row.claimedQty))])]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "claimDate",
      "label": "Claim Date",
      "width": "160px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.formatDate(scope.row.claimDate)) + "\n\t\t\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Status",
      "width": "120px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          attrs: {
            "type": _vm.getClaimStatusTagType(scope.row.claimStatus),
            "size": "small"
          }
        }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.getClaimStatusText(scope.row.claimStatus)) + "\n\t\t\t\t\t\t\t")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "reviewReason",
      "label": "Review Note",
      "min-width": "200px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.reviewReason) ? _c('p', [_vm._v(_vm._s(scope.row.reviewReason))]) : _c('span', {
          staticClass: "note"
        }, [_vm._v("—")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Actions",
      "min-width": "140",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "action-buttons"
        }, [(scope.row.claimStatus === 0) ? _c('el-button', {
          staticClass: "action-btn",
          attrs: {
            "size": "mini",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.cancelClaim(scope.row)
            }
          }
        }, [_vm._v("\n\t\t\t\t\t\t\t\t\tCancel\n\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), _c('el-button', {
          staticClass: "action-btn",
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.viewClaimDetail(scope.row)
            }
          }
        }, [_vm._v("\n\t\t\t\t\t\t\t\t\tView\n\t\t\t\t\t\t\t\t")])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.myClaimCurrentPage,
      "page-sizes": [10, 20, 50, 100],
      "page-size": _vm.myClaimSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.myClaimTotal
    },
    on: {
      "size-change": _vm.handleMyClaimSizeChange,
      "current-change": _vm.handleMyClaimCurrentChange
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Batch Upload Claims (Nurse)",
      "width": "85%",
      "visible": _vm.batchImportVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.batchImportVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.batchImportForm
    }
  }, [_c('el-form-item', [_c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('strong', [_vm._v("Selected Inbound:")]), _vm._v(" " + _vm._s(_vm.selectedInboundInfo ? _vm.selectedInboundInfo.productName : 'Not selected') + "\n\t\t\t\t\t"), (_vm.selectedInboundInfo) ? _c('span', {
    staticStyle: {
      "color": "#909399",
      "font-size": "12px"
    }
  }, [_vm._v("(" + _vm._s(_vm.selectedInboundInfo.inboundNo) + ")")]) : _vm._e()])]), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": "12",
      "placeholder": _vm.batchImportPlaceholder
    },
    model: {
      value: (_vm.batchImportText),
      callback: function($$v) {
        _vm.batchImportText = $$v
      },
      expression: "batchImportText"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "note",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('strong', [_vm._v("Format: Tracking,Quantity or Tracking Quantity (one record per line)")]), _vm._v(" "), _c('br'), _vm._v("Supports separators: comma, space, or tab\n\t\t\t\t\t"), _c('br'), _vm._v("Examples:\n\t\t\t\t\t"), _c('br'), _vm._v("123456789012,5\n\t\t\t\t\t"), _c('br'), _vm._v("234567890123\t10\n\t\t\t\t\t"), _c('br'), _vm._v("345678901234 3\n\t\t\t\t")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.batchImportVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.batchImportLoading
    },
    on: {
      "click": _vm.importBatchClaims
    }
  }, [_vm._v("Import to Claim List")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Batch Upload Claims (Doctor)",
      "width": "85%",
      "visible": _vm.doctorBatchImportVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.doctorBatchImportVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.batchImportForm
    }
  }, [_c('el-form-item', [_c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('strong', [_vm._v("Selected Warehouse:")]), _vm._v(" " + _vm._s(_vm.claimForm.warehouseNo ? _vm.getWarehouseNameByNo(_vm.claimForm.warehouseNo) : 'Not selected') + "\n\t\t\t\t")])]), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": "12",
      "placeholder": _vm.doctorBatchImportPlaceholder
    },
    model: {
      value: (_vm.doctorBatchImportText),
      callback: function($$v) {
        _vm.doctorBatchImportText = $$v
      },
      expression: "doctorBatchImportText"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "note",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('strong', [_vm._v("Format: Tracking,UPC,Quantity or Tracking UPC Quantity (one record per line)")]), _vm._v(" "), _c('br'), _vm._v("Supports separators: comma, space, or tab\n\t\t\t\t\t"), _c('br'), _vm._v("Examples:\n\t\t\t\t\t"), _c('br'), _vm._v("123456789012,012345678901,5\n\t\t\t\t\t"), _c('br'), _vm._v("234567890123\t098765432109\t10\n\t\t\t\t\t"), _c('br'), _vm._v("345678901234 111111111111 3\n\t\t\t\t")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.doctorBatchImportVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.doctorBatchImportLoading
    },
    on: {
      "click": _vm.importDoctorBatchClaims
    }
  }, [_vm._v("Import to Claim List")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Claim Detail",
      "visible": _vm.claimDetailDialog,
      "width": "60%"
    },
    on: {
      "update:visible": function($event) {
        _vm.claimDetailDialog = $event
      }
    }
  }, [(_vm.claimDetail) ? _c('div', [_c('el-descriptions', {
    attrs: {
      "title": "Claim Information",
      "column": 2,
      "border": ""
    }
  }, [_c('el-descriptions-item', {
    attrs: {
      "label": "Tracking #"
    }
  }, [_vm._v(_vm._s(_vm.claimDetail.tracking))]), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "label": "UPC"
    }
  }, [_vm._v(_vm._s(_vm.claimDetail.upc))]), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "label": "Original Claimed Qty"
    }
  }, [_vm._v(_vm._s(_vm.claimDetail.originalClaimedQty || _vm.claimDetail.claimedQty))]), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "label": "Final Quantity"
    }
  }, [_vm._v(_vm._s(_vm.claimDetail.claimedQty))]), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "label": "Claim Date"
    }
  }, [_vm._v(_vm._s(_vm.formatDate(_vm.claimDetail.claimDate)))]), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "label": "Status"
    }
  }, [_c('el-tag', {
    attrs: {
      "type": _vm.getClaimStatusTagType(_vm.claimDetail.claimStatus)
    }
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.getClaimStatusText(_vm.claimDetail.claimStatus)) + "\n\t\t\t\t\t")])], 1), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "label": "Review Note",
      "span": 2
    }
  }, [(_vm.claimDetail.reviewReason) ? _c('p', [_vm._v(_vm._s(_vm.claimDetail.reviewReason))]) : _c('span', {
    staticClass: "note"
  }, [_vm._v("No review note")])])], 1)], 1) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.showScrollToTopButton) ? _c('el-button', {
    staticClass: "scroll-to-top-button",
    attrs: {
      "type": "primary",
      "icon": "el-icon-arrow-up",
      "circle": "",
      "title": "Scroll to top"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleScrollToTopClick.apply(null, arguments)
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), (false) ? _c('div', {
    staticClass: "debug-scroll-info"
  }, [_vm._v("\n\t\tshowScrollToTopButton: " + _vm._s(_vm.showScrollToTopButton) + ", scrollY: " + _vm._s(_vm.window.pageYOffset) + "\n\t")]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-701242b4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/mixedPackageClaim.vue
// module id = 836
// module chunks = 1